// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "img[data-v-7fee40fa]{background-color:#214282}.img_caption[data-v-7fee40fa]{cursor:pointer;position:absolute;top:10%;left:20%;width:60%;text-align:center;overflow:hidden;text-overflow:ellipsis;background-color:hsla(0,0%,100%,.6);-webkit-backdrop-filter:blur(10px) opacity(50%);backdrop-filter:blur(10px) opacity(50%);border-radius:.25em;padding:10px}.cntr[data-v-7fee40fa]{justify-content:center}.spc-btwn[data-v-7fee40fa]{justify-content:space-between}", ""]);
// Exports
module.exports = exports;
